import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-sbrnexus',
  templateUrl: './sbrnexus.component.html'
})
export class SBRNexusComponent implements OnInit {
  @Input('SBRNexus') sbrNexus: string = 'BTP';
  @Input('environment') environment!: any;
  @Output('UpdateOrganisationSettings') updateOrganisationSettings: EventEmitter<any> = new EventEmitter<any>();

   
  constructor() {
    // Must not be empty. It's approved by a comment.
  }

  ngOnInit(): void {
    // Must not be empty. It's approved by a comment.
  }

  updateValue(key:string, value:string){
    this.updateOrganisationSettings.emit([{key:key, value:value}])
  }

}
